// src/pages/UnpaidOrdersPage.jsx

import React, { useState } from 'react';
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  useToast,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from '@chakra-ui/react';
import { formatDistanceToNow, subDays } from 'date-fns';

const now = new Date();

const fakeOrders = [
  { id: 'ord-001', paid: false, createdAt: subDays(now, 1), customer: 'Alice' },
  { id: 'ord-002', paid: false, createdAt: subDays(now, 15), customer: 'Bob' },
  { id: 'ord-003', paid: false, createdAt: subDays(now, 29), customer: 'Charlie' },
  { id: 'ord-004', paid: false, createdAt: subDays(now, 45), customer: 'Dana' },
  { id: 'ord-005', paid: false, createdAt: subDays(now, 62), customer: 'Edgar' },
  { id: 'ord-006', paid: true, createdAt: subDays(now, 10), customer: 'Faith' },
  { id: 'ord-007', paid: true, createdAt: subDays(now, 20), customer: 'Grace' },
];

const getColorScheme = (days) => {
  if (days >= 60) return 'red';
  if (days >= 45) return 'orange';
  if (days >= 30) return 'yellow';
  if (days >= 15) return 'blue';
  return 'green';
};

const UnpaidOrdersPage = () => {
  const [cooldownOrderId, setCooldownOrderId] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const toast = useToast();

  const unpaidOrders = fakeOrders
    .filter((o) => !o.paid)
    .sort((a, b) => a.createdAt - b.createdAt);

  const handleReminder = () => {
    toast({ title: `Reminder sent to ${selectedOrder.customer}`, status: 'info' });
    setCooldownOrderId(selectedOrder.id);
    setTimeout(() => setCooldownOrderId(null), 60000); // 1 min cooldown
    onClose();
  };

  return (
    <Box p={8}>
      <Heading mb={6}>Unpaid Orders</Heading>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Order ID</Th>
            <Th>Customer</Th>
            <Th>Age</Th>
            <Th>Status</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {unpaidOrders.map((order) => {
            const daysOld = Math.floor((now - order.createdAt) / (1000 * 60 * 60 * 24));
            const scheme = getColorScheme(daysOld);
            return (
              <Tr key={order.id}>
                <Td>{order.id}</Td>
                <Td>{order.customer}</Td>
                <Td>
                  <Badge colorScheme={scheme}>{formatDistanceToNow(order.createdAt)} ago</Badge>
                </Td>
                <Td>
                  {daysOld >= 60 ? (
                    <Badge colorScheme="red">OUT OF PAYMENT WINDOW</Badge>
                  ) : (
                    <Badge colorScheme="yellow">Unpaid</Badge>
                  )}
                </Td>
                <Td>
                  <Button
                    size="sm"
                    colorScheme="blue"
                    isDisabled={cooldownOrderId === order.id}
                    onClick={() => {
                      setSelectedOrder(order);
                      onOpen();
                    }}
                  >
                    Send Reminder
                  </Button>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Send Reminder</AlertDialogHeader>
            <AlertDialogBody>
              Are you sure you want to send a reminder for <b>{selectedOrder?.id}</b>?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>Cancel</Button>
              <Button colorScheme="blue" onClick={handleReminder} ml={3}>Send</Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default UnpaidOrdersPage;